<template>
  <div>
    <table-view
      :isBusy="isLoading"
      :fields="fields"
      :items="list"
      title="Qualification"
    >
      <template v-slot:add>
        <create-qualification
          @init="init"
          v-if="isCreate"
        ></create-qualification>
      </template>
      <template v-slot:status="{ value }">
        {{ value == 1 ? "Active" : "Deleted" }}
      </template>
      <template v-slot:action="{ item }">
        <div class="d-flex" v-if="isAction(item)">
          <create-qualification
            :item="item"
            @init="init"
          ></create-qualification>
          <delete-button @click="remove(item)"></delete-button>
        </div>
      </template>
    </table-view>
  </div>
</template>

<script>
import menuConstants from "../../assets/constants/menu.constants";
import masterService from "../../assets/services/master.service";
import DeleteButton from "../buttons/DeleteButton.vue";
import TableView from "../table/TableView.vue";
import CreateQualification from "./create/CreateQualification.vue";
export default {
  components: { TableView, DeleteButton, CreateQualification },
  data() {
    return {
      list: [],
      isLoading: false,
    };
  },
  computed: {
    fields() {
      let doc = {
        qualification_name: "Qualification Name",
        status: "Status",
        action: "Action",
      };
      let list = [];
      Object.keys(doc).forEach((key) => {
        list.push({
          key,
          sortable: true,
          label: doc[key],
          tdClass: key == "action" ? "width-100" : "",
        });
      });
      return list;
    },
    isCreate() {
      return this.hasCreateAccess(menuConstants.QUALIFICATION);
    },
  },
  methods: {
    isAction({ status }) {
      if (!this.hasStatusAccess(menuConstants.QUALIFICATION, 4)) return false;
      return status == 1;
    },
    async remove({ qualification_id }) {
      const vm = this;
      vm.$confirm.show({
        message: "Are you sure, Do you want to remove this?",
        onConfirm: async () => {
          try {
            let { data } = await masterService.CUDQualification({
              qualification_id,
              dml_indicator: "D",
              status: 4,
            });
            let { status, msg } = data;
            vm.init();
            if (!status) {
              vm.$alert.show(msg);
            }
          } catch (error) {
            vm.isLoading = false;
            vm.$alert.show(error.message);
          }
        },
      });
    },
    async init() {
      const vm = this;
      try {
        vm.list = [];
        vm.isLoading = true;
        let { data } = await masterService.getQualification();
        let { status, msg, list } = data;
        vm.isLoading = false;
        if (status) {
          vm.list = list;
        } else {
          vm.$alert.show(msg);
        }
      } catch (error) {
        vm.isLoading = false;
        vm.$alert.show(error.message);
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style></style>
